/**
 * Tâches Franz pour les exports logiciels PV (équivalent legacy `modules/pv/constants.js`
 * + `constants/task-type.js`).
 */

export const EXPORT_PV_TYPES = {
    PVSOL: "export-data-pvsol",
    AUTOCALSOL: "export-data-autocalsol",
    ARCHELIOSPRO: "export-data-archeliospro",
    PYSYST: "export-data-pvsyst",
    SOLARIUS: "export-data-solarius",
    FRONIUS_SOLAR: "export-data-fronius-solar",
    SOLAREDGE_DESIGNER: "export-data-solaredge-designer",
    SUNNY_DESIGN: "export-data-sunny-design",
} as const

export type ExportPvTypeKey = keyof typeof EXPORT_PV_TYPES

export const EXPORT_EXTRAPOLATION_PV_TYPES: Record<ExportPvTypeKey, string> = {
    PVSOL: "pvsol",
    AUTOCALSOL: "autocalsol",
    ARCHELIOSPRO: "archeliospro",
    PYSYST: "pvsyst",
    SOLARIUS: "solarius",
    FRONIUS_SOLAR: "froniussolar",
    SOLAREDGE_DESIGNER: "solaredgedesigner",
    SUNNY_DESIGN: "sunnydesign",
}

/** Tâche export extrapolé depuis une source */
export const PV_EXTRAPOLATE_SOURCE_EXPORT =
    "analyses.export_source_pv.request" as const

const DATA_BUILDING_EXPORT_AUTOCALSOL =
    "building.export_autocalsol_building.request"
const DATA_BUILDING_EXPORT_PVSOL = "building.export_pvsol_building.request"
const DATA_BUILDING_EXPORT_ARCHELIOS_PRO =
    "building.export_archeliospro_building.request"
const DATA_BUILDING_EXPORT_PVSYST = "building.export_pvsyst_building.request"
const DATA_BUILDING_EXPORT_SOLARIUS =
    "building.export_solarius_building.request"
const DATA_BUILDING_EXPORT_FRONIUS_SOLAR =
    "building.export_froniussolar_building.request"
const DATA_BUILDING_EXPORT_SOLAREDGE_DESIGNER =
    "building.export_solaredgedesigner_building.request"
const DATA_BUILDING_EXPORT_SUNNY_DESIGN =
    "building.export_sunnydesign_building.request"

const DATA_SOURCE_EXPORT_AUTOCALSOL = "source.export_autocalsol_source.request"
const DATA_SOURCE_EXPORT_PVSOL = "source.export_pvsol_source.request"
const DATA_SOURCE_EXPORT_ARCHELIOS_PRO =
    "source.export_archeliospro_source.request"
const DATA_SOURCE_EXPORT_PYSYST = "source.export_pvsyst_source.request"
const DATA_SOURCE_EXPORT_SOLARIUS = "source.export_solarius_source.request"
const DATA_SOURCE_EXPORT_FRONIUS_SOLAR =
    "source.export_froniussolar_source.request"
const DATA_SOURCE_EXPORT_SOLAREDGE_DESIGNER =
    "source.export_solaredgedesigner_source.request"
const DATA_SOURCE_EXPORT_SUNNY_DESIGN =
    "source.export_sunnydesign_source.request"

export const EXPORT_PV_BUILDING_TO_TASK: Record<string, string> = {
    [EXPORT_PV_TYPES.AUTOCALSOL]: DATA_BUILDING_EXPORT_AUTOCALSOL,
    [EXPORT_PV_TYPES.PVSOL]: DATA_BUILDING_EXPORT_PVSOL,
    [EXPORT_PV_TYPES.ARCHELIOSPRO]: DATA_BUILDING_EXPORT_ARCHELIOS_PRO,
    [EXPORT_PV_TYPES.PYSYST]: DATA_BUILDING_EXPORT_PVSYST,
    [EXPORT_PV_TYPES.SOLARIUS]: DATA_BUILDING_EXPORT_SOLARIUS,
    [EXPORT_PV_TYPES.FRONIUS_SOLAR]: DATA_BUILDING_EXPORT_FRONIUS_SOLAR,
    [EXPORT_PV_TYPES.SOLAREDGE_DESIGNER]:
        DATA_BUILDING_EXPORT_SOLAREDGE_DESIGNER,
    [EXPORT_PV_TYPES.SUNNY_DESIGN]: DATA_BUILDING_EXPORT_SUNNY_DESIGN,
}

export const EXPORT_PV_SOURCE_TO_TASK: Record<string, string> = {
    [EXPORT_PV_TYPES.AUTOCALSOL]: DATA_SOURCE_EXPORT_AUTOCALSOL,
    [EXPORT_PV_TYPES.PVSOL]: DATA_SOURCE_EXPORT_PVSOL,
    [EXPORT_PV_TYPES.ARCHELIOSPRO]: DATA_SOURCE_EXPORT_ARCHELIOS_PRO,
    [EXPORT_PV_TYPES.PYSYST]: DATA_SOURCE_EXPORT_PYSYST,
    [EXPORT_PV_TYPES.SOLARIUS]: DATA_SOURCE_EXPORT_SOLARIUS,
    [EXPORT_PV_TYPES.FRONIUS_SOLAR]: DATA_SOURCE_EXPORT_FRONIUS_SOLAR,
    [EXPORT_PV_TYPES.SOLAREDGE_DESIGNER]: DATA_SOURCE_EXPORT_SOLAREDGE_DESIGNER,
    [EXPORT_PV_TYPES.SUNNY_DESIGN]: DATA_SOURCE_EXPORT_SUNNY_DESIGN,
}
